import { useOptimizedRecord } from '@/shared/hooks/useOptimizedQuery'

import type { PassRewardDetail } from '../types'

/**
 * Recompensas entregues num resgate de passe — recompensa de conclusão (tier) ou
 * missão do passe (objetivo). Vem do snapshot gravado no momento do resgate, então
 * reflete o que o aluno recebeu, não o que o passe oferece hoje. Alimenta o modal
 * aberto ao clicar numa linha de Passe.
 */
export function usePassRewardDetails(progressResourceId: number | null) {
  return useOptimizedRecord<PassRewardDetail>({
    path: '/user/content_history/pass_reward_details',
    params:
      progressResourceId != null ? { progress_resource_id: progressResourceId } : undefined,
    enabled: progressResourceId != null,
    skipInitialData: true
  })
}
